/** Cutier auf eigener Origin (cutier-hub.web.app) — PE One mit scope "/" klaut sonst alle Links. */
export const isCutierHost = (hostname: string = window.location.hostname): boolean => {
  const h = String(hostname || '').toLowerCase();
  return (
    h === 'cutier-hub.web.app' ||
    h === 'cutier-hub.firebaseapp.com' ||
    h.startsWith('cutier.') ||
    h.includes('cutier-hub')
  );
};
